<template>
  <CModal
    class="modal__footer-empty"
    :title="contents.title || ''"
    centered
    :show="show"
    @update:show="closeModal"
  >
    <h5 class="text-center" v-if="contents.header">{{contents.header}}</h5>
    <p class="text-center pt-3" v-html="contents.body"></p>

    <button
      class="btn btn-primary btn-block w-100"
      v-if="contents.buttonText"
      @click="onClickButton"
      >
      {{ contents.buttonText }}
    </button>
  </CModal>
</template>

<script>
import {
  createModalMixin,
  modalStore
} from '@/mixins/modalsMixin'

export default {
  name: 'TheDefaultModal',

  mixins: [createModalMixin()],

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    contents() {
      return this[modalStore.getterTypes.GETTER_MODAL_CONTENTS] || {}
    }
  },

  methods: {
    onClickButton() {
      if (this.contents.onClickButton && typeof this.contents.onClickButton === 'function') {
        this.contents.onClickButton()
      }
    },
    closeModal() {
      this.$store.dispatch(
        `${modalStore.moduleName}/${modalStore.actionTypes.ACTION_SET_MODAL_CONTENTS}`,
        null
      );
      this.$emit("close");
    },
  }
}
</script>
